import { normalizeCustomerType } from '../../../utils/userTypeMapper';

/**
 * Check if a menu item should be displayed based on customer type
 * Preserves WordPress header.php visibility logic with special cases
 */
export function shouldShowMenuItem(displayFor: string[] | undefined, custType: string): boolean {
  // If no display_for specified, show to everyone
  if (!displayFor || displayFor.length === 0) {
    return true;
  }
  
  // Show if 'all' is in the array
  if (displayFor.includes('all')) {
    return true;
  }
  
  // Normalize customer type for special cases (r2stb -> 001, 000 -> 002)
  const normalizedCustType = normalizeCustomerType(custType);
  
  // Show if current customer type matches
  if (displayFor.includes(normalizedCustType)) {
    return true;
  }
  
  return false;
}
